import { render, staticRenderFns } from "./Feedback.vue?vue&type=template&id=20c702aa&scoped=true"
import script from "./Feedback.vue?vue&type=script&lang=js"
export * from "./Feedback.vue?vue&type=script&lang=js"
import style0 from "./Feedback.vue?vue&type=style&index=0&id=20c702aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c702aa",
  null
  
)

export default component.exports